/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const slider = document.querySelector('.doctor-credentials .splide');

if( slider ) {
    var splide = new Splide( '.doctor-credentials .splide' , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: false,
        perPage: 5,
        perMove: 1,
        autoScroll: {
            speed: .8,
        },
        breakpoints: {
            1024: {
                perPage: 4,
            },
            960: {
                perPage: 3,
            },
            768: {
                perPage: 2,
            },
        }
    });
    splide.mount({ AutoScroll });
}